<div [ngClass]="'app ' + themeService.brand">
  @if (
    applicationInitiated() &&
    brandService.brand &&
    channelRequestService.channelRequest &&
    !error()
  ) {
    <vw-navigation></vw-navigation>
    <vw-toasts></vw-toasts>
    <vw-top-banner></vw-top-banner>
    <vw-redirect-brand></vw-redirect-brand>
    <vw-cookie-consent></vw-cookie-consent>
    <router-outlet></router-outlet>
  }

  @if (error()) {
    <vw-error-page (tryAgain$)="tryAgain()"></vw-error-page>
  }
</div>
